import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '@shared/domain/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  activeCalls = 0;

  constructor(private loadingService: LoadingService) {}
  intercept<T, K>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<K>> {
    this.loadingService.loading = ++this.activeCalls;

    return next.handle(request).pipe(
      finalize(() => {
        this.loadingService.loading = --this.activeCalls;
      }),
    );
  }
}
